module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAu0lEQVR4AZyOMQ4CIRBFWZs9gBfRJXAQi72BpWfYxhN4hK32GlYkJJREC66gCR1agDOIBhGLlcwLf/7MDyzIzPN/gDHWU0p3Nbqu618fiS9wzpfe+wnMQ42maSbcgRmJASnlBZoB+FVD2nkGcEsptYd7BMoa0yz68YWoCAnOuW0I4Zh6gho96AMQKw8QrfW9bdsNTE7AGTV6oN/1EUBXCHG11q6ttSvU6OV8BXBojLkhqEuqgXIp72cHHgAAAP//0/6LDAAAAAZJREFUAwBGmk0Z2SXIIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aroow.png
// module id = JDhN
// module chunks = 167